// extracted by mini-css-extract-plugin
export default {"content":"MentionContent_content__AXTUl"};